export const FILE_ACCEPTED_TYPES = [
  // Images
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  // Video
  '.mp4',
  '.webm',
  // Documents
  '.pdf',
  '.doc',
  '.docx',
  // Plain Text
  '.csv',
];

export const SUPPORTED_CHANNEL_TYPES = [
  'Channel::FacebookPage',
  'Channel::Instagram',
  'Channel::Zalo',
  'Channel::Shopee',
  'Channel::Lazada',
  'Channel::TiktokShop',
];
